var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220.22 220.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#222221;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.39,223.5h0A110.11,110.11,0,0,1,3.27,113.39h0A110.11,110.11,0,0,1,113.39,3.28h0A110.11,110.11,0,0,1,223.5,113.39h0A110.11,110.11,0,0,1,113.39,223.5Z",
    transform: "translate(-3.27 -3.28)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.39,63.89c16.12,0,18,.06,24.39.35A33.34,33.34,0,0,1,149,66.32a20,20,0,0,1,11.46,11.46A33.34,33.34,0,0,1,162.53,89c.29,6.37.35,8.28.35,24.4s-.06,18-.35,24.39A33.28,33.28,0,0,1,160.45,149,20,20,0,0,1,149,160.45a33.34,33.34,0,0,1-11.21,2.08c-6.36.29-8.27.35-24.39.35s-18-.06-24.4-.35a33.34,33.34,0,0,1-11.21-2.08,18.62,18.62,0,0,1-6.94-4.51A18.88,18.88,0,0,1,66.32,149a33.28,33.28,0,0,1-2.08-11.21c-.29-6.36-.35-8.27-.35-24.39s.06-18,.35-24.4a33.34,33.34,0,0,1,2.08-11.21A20,20,0,0,1,77.78,66.32,33.34,33.34,0,0,1,89,64.24c6.37-.29,8.28-.35,24.4-.35m0-10.88c-16.4,0-18.46.07-24.9.37a44.31,44.31,0,0,0-14.65,2.8A31,31,0,0,0,56.18,73.84a44.31,44.31,0,0,0-2.8,14.65c-.3,6.44-.37,8.5-.37,24.9s.07,18.45.37,24.89a44.31,44.31,0,0,0,2.8,14.65,30.88,30.88,0,0,0,17.66,17.66,44.54,44.54,0,0,0,14.65,2.81c6.44.29,8.5.36,24.9.36s18.45-.07,24.89-.36a44.54,44.54,0,0,0,14.65-2.81,30.8,30.8,0,0,0,17.66-17.66,44.54,44.54,0,0,0,2.81-14.65c.29-6.44.36-8.5.36-24.89s-.07-18.46-.36-24.9a44.54,44.54,0,0,0-2.81-14.65,30.88,30.88,0,0,0-17.66-17.66,44.31,44.31,0,0,0-14.65-2.8c-6.44-.3-8.5-.37-24.89-.37",
    transform: "translate(-3.27 -3.28)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.39,82.38a31,31,0,1,0,31,31,31,31,0,0,0-31-31m0,51.13a20.13,20.13,0,1,1,20.12-20.12,20.12,20.12,0,0,1-20.12,20.12",
    transform: "translate(-3.27 -3.28)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.86,81.16a7.25,7.25,0,1,1-7.25-7.25,7.24,7.24,0,0,1,7.25,7.25",
    transform: "translate(-3.27 -3.28)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta1);
export default __webpack_public_path__ + "static/media/insta1.dbf4c7504e1eeceabcc197abba7a3649.svg";
export { ForwardRef as ReactComponent };